import React from 'react';
import { Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function CtaSection() {
  return <section className="py-20 bg-cream text-center px-4" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-16">
          <h2 className="font-handwritten text-5xl md:text-6xl text-forestGreen mb-4" data-id="element-17">
            Ruhige Morgen für dich und deinen Hund
          </h2>
          <p className="font-serif text-xl text-warmBrown mb-10" data-id="element-18">
            Teste das Magen-Darm-Topping jetzt risikofrei – mit
            Geld-zurück-Garantie.
          </p>

          <div className="flex items-center justify-center gap-2 mb-6 text-warmBrown" data-id="element-19">
            <div className="flex gap-0.5" data-id="element-20">
              {[...Array(4)].map((_, i) => <svg key={i} className="w-4 h-4 fill-warmBrown" viewBox="0 0 20 20" data-id="element-21">
                  <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" data-id="element-22" />
                </svg>)}
              <svg className="w-4 h-4" viewBox="0 0 20 20" data-id="element-23">
                <defs data-id="element-24">
                  <linearGradient id="halfStar" data-id="element-25">
                    <stop offset="40%" stopColor="#8B4513" data-id="element-26" />
                    <stop offset="40%" stopColor="#D4C4B0" data-id="element-27" />
                  </linearGradient>
                </defs>
                <path fill="url(#halfStar)" d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" data-id="element-28" />
              </svg>
            </div>
            <span className="font-serif text-sm" data-id="element-29">
              4,4/5 · 876 Hundehalter haben es bewertet
            </span>
          </div>

          <div className="mb-4" data-id="element-30">
            <CtaButton label="Hilf auch deinem Hund — natürlich & sanft" position="bottom_cta" data-id="element-31" />
          </div>

          <p className="text-[13px] text-gray-500 italic font-serif mb-8 max-w-md mx-auto" data-id="element-32">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm font-serif text-gray-600" data-id="element-33">
            <div className="flex items-center gap-1" data-id="element-34">
              <Check className="w-4 h-4 text-forestGreen" data-id="element-35" />
              <span data-id="element-36">Schneller Versand</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-37">
              <Check className="w-4 h-4 text-forestGreen" data-id="element-38" />
              <span data-id="element-39">Zufriedenheitsgarantie</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-40">
              <Check className="w-4 h-4 text-forestGreen" data-id="element-41" />
              <span data-id="element-42">100% Natürliche Inhaltsstoffe</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}